import { useEffect, useState } from 'react';

import debounce from 'lodash/debounce';

import { getWindowSafe } from '@change-corgi/core/window';

export function useDebouncedScreenWidth() {
	const window = getWindowSafe();

	const [width, setWidth] = useState(window?.innerWidth || 0);

	useEffect(() => {
		if (!window) return () => {};

		const handleResize = debounce(() => setWidth(window.innerWidth), 100);

		window.addEventListener('resize', handleResize);

		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, [window]);

	return width;
}
